/*
 * Collection "tekil mod" helpers.
 * Dedupes color-family cards and backfills via infinite-scroll when available.
 * Safe with facets AJAX (ProductGridContainer replace).
 */
(function () {
  const MODE = {
    isProductCard(el) {
      if (!el || !el.classList || !el.classList.contains('grid__item')) return false;
      if (el.classList.contains('grid__item--banner')) return false;
      if (el.classList.contains('grid__item--banner-cell')) return false;
      return true;
    },

    isTekil(grid) {
      return Boolean(grid && grid.dataset.productMode === 'tekil');
    },

    resolveGrid(root) {
      let grid = root || document.getElementById('product-grid');
      if (!grid) return null;
      if (grid.matches('ul')) return grid;
      return grid.querySelector('ul.product-grid, ul[role="list"]') || grid;
    },

    countProducts(grid) {
      grid = MODE.resolveGrid(grid);
      if (!grid) return 0;
      return Array.from(grid.children).filter((el) => MODE.isProductCard(el)).length;
    },

    targetCount(grid) {
      grid = MODE.resolveGrid(grid);
      const n = parseInt(grid && grid.dataset.productsPerPage, 10);
      return Number.isFinite(n) && n > 0 ? n : 50;
    },

    dedupe(grid, seen = new Set()) {
      grid = MODE.resolveGrid(grid);
      if (!grid || !MODE.isTekil(grid)) return seen;
      Array.from(grid.children).forEach((el) => {
        if (!MODE.isProductCard(el)) return;
        const key = el.dataset.familyKey;
        if (!key) return;
        if (seen.has(key)) {
          el.remove();
          return;
        }
        seen.add(key);
      });
      return seen;
    },

    filterIncoming(items, seen, tekil) {
      if (!tekil) return items;
      const kept = [];
      items.forEach((el) => {
        if (!MODE.isProductCard(el)) {
          kept.push(el);
          return;
        }
        const key = el.dataset.familyKey;
        if (key && seen.has(key)) return;
        if (key) seen.add(key);
        kept.push(el);
      });
      return kept;
    },

    findScroll() {
      return (
        document.querySelector('product-grid-infinite-scroll') ||
        document.querySelector('collection-infinite-scroll')
      );
    },

    async backfill(grid) {
      grid = MODE.resolveGrid(grid);
      if (!grid || !MODE.isTekil(grid) || grid.dataset.tekilBackfilling === '1') return;

      const scroll = MODE.findScroll();
      if (!scroll) return;
      if (scroll.bootstrapped === false) return;

      const load =
        typeof scroll.loadNextPage === 'function'
          ? (opts) => scroll.loadNextPage(opts)
          : typeof scroll.loadMore === 'function'
            ? (opts) => scroll.loadMore(opts)
            : null;
      if (!load) return;

      grid.dataset.tekilBackfilling = '1';
      try {
        let guard = 0;
        const target = MODE.targetCount(grid);
        while (MODE.countProducts(grid) < target && guard < 24) {
          guard += 1;
          const endBefore = scroll.endPage ?? scroll.currentPage ?? 0;
          const total = scroll.totalPages ?? 0;
          if (total && endBefore >= total) break;

          const before = MODE.countProducts(grid);
          await load({ silent: true });

          const endAfter = scroll.endPage ?? scroll.currentPage ?? endBefore;
          // A page may add 0 cards (all tekil dupes) but still advance — keep going.
          if (MODE.countProducts(grid) <= before && endAfter <= endBefore) break;
        }
      } finally {
        delete grid.dataset.tekilBackfilling;
      }
    },

    async apply(grid) {
      grid = MODE.resolveGrid(grid);
      if (!grid || !MODE.isTekil(grid)) return;
      MODE.dedupe(grid);
      await MODE.backfill(grid);
    },

    bindFacets() {
      if (typeof FacetFiltersForm === 'undefined') return;
      if (FacetFiltersForm.__nodusTekilPatched) return;
      const original = FacetFiltersForm.renderProductGridContainer;
      if (typeof original !== 'function') return;

      FacetFiltersForm.renderProductGridContainer = function patched(html) {
        original.call(this, html);
        // Infinite-scroll CE reconnects on replace; it will backfill when ready.
        const grid = MODE.resolveGrid();
        if (grid && MODE.isTekil(grid)) MODE.dedupe(grid);
      };
      FacetFiltersForm.__nodusTekilPatched = true;
    },

    init() {
      MODE.bindFacets();
      // Initial tekil pass; backfill is owned by infinite-scroll after bootstrap.
      const grid = MODE.resolveGrid();
      if (grid && MODE.isTekil(grid)) MODE.dedupe(grid);
    },
  };

  window.NodusCollectionProductMode = MODE;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => MODE.init(), { once: true });
  } else {
    MODE.init();
  }
})();
